import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Icon, Menu} from 'semantic-ui-react';
import {volumeChange} from '../actions/volume';

class SettingsMenu extends Component {
    shouldComponentUpdate({settings: volume}) {
        return volume !== this.props.settings.volume;
    }
    render() {
        const {volume} = this.props.settings;
        return <Menu.Menu position='right'>
            <Menu.Item>
                <Icon name='volume off'/>
                <input
                    type="range"
                    min="0"
                    max="1"
                    step="0.01"
                    onChange={({target}) => this.props.volumeChange(target.value)}
                    value={volume}/>
            </Menu.Item>
        </Menu.Menu>;
    }
}

SettingsMenu.propTypes = {
    settings: PropTypes
        .shape({volume: PropTypes.number})
        .isRequired,
    volumeChange: PropTypes.func.isRequired
};
export default connect(({settings}) => ({settings}), {volumeChange})(SettingsMenu);


// WEBPACK FOOTER //
// ./src/containers/Settings.js